import './font.module.css';
import './vars.module.css';
import './global.module.css';

const Body = ({ children }) => (<>{children}</>);

export default Body;
